var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7.25,
    stroke: "#1F845A",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.154 12.885a.3.3 0 00.424 0l4.741-4.742a.3.3 0 000-.424l-.707-.707a.3.3 0 00-.424 0l-3.61 3.61a.3.3 0 01-.424 0l-1.81-1.81a.3.3 0 00-.425 0l-.707.707a.3.3 0 000 .425l2.942 2.94z",
    fill: "#1F845A"
  })));
}
export default SvgSuccess;